



















































































import Vue, { PropType } from "vue";

import Loading from "../general/Loading.vue";
import WidgetDatetime from "../general/WidgetDatetime.vue";

import CategoryTypeJson from "../../shared/CategoryTypeJson";

export type TableViewColumnDefinitions<T> = {
  th: string;
  td: keyof T | ((item: T) => string);
  sortBy?: keyof T | ((item: T) => string);
  button?: string | ((item: T) => Function);
  image?: string | ((item: T) => Function);
  dateWidget?: Date | ((item: T) => Function);
  categoryLabel?: any[] | ((item: T) => any[]);
  class?: string | ((item: T) => string);
  style?: string | ((item: T) => string);
};

export default Vue.extend({
  name: "TableView",
  components: {
    Loading,
    WidgetDatetime,
  },
  props: {
    items: Array as PropType<any[]>,
    columns: Array as PropType<TableViewColumnDefinitions<any>[]>,
    isSortingDisabled: Boolean,
    isItemClickDisabled: Boolean,
    isSelectable: Boolean,
  },
  data() {
    return {
      sortByColumnIndex: null as number | null,
      sortAscending: false,
      selectedTableItems: [] as any[],
    };
  },
  methods: {
    changeSortMode(sortByColumnIndex: number): void {
      if (!this.isSortingDisabled) {
        if (this.sortByColumnIndex == sortByColumnIndex) {
          this.sortAscending = !this.sortAscending;
        } else {
          this.sortByColumnIndex = sortByColumnIndex;
          this.sortAscending = true;
        }
      }
    },

    isContentButton(column: TableViewColumnDefinitions<any>): boolean {
      if (column.button) {
        return true;
      } else {
        return false;
      }
    },

    isContentDateWidget(column: TableViewColumnDefinitions<any>): boolean {
      if (column.dateWidget) {
        return true;
      } else {
        return false;
      }
    },

    isContentImage(column: TableViewColumnDefinitions<any>): boolean {
      if (column.image) {
        return true;
      } else {
        return false;
      }
    },

    isContentCategoryLabel(column: TableViewColumnDefinitions<any>): boolean {
      if (column.categoryLabel) {
        return true;
      } else {
        return false;
      }
    },

    getValue(content: string | ((item: any) => string) | undefined, item: any): string | null {
      return content ? (typeof content === "function" ? content(item) : item[content]) : null;
    },

    getCategoryLabels(content: (item: any) => CategoryTypeJson[], item: any): CategoryTypeJson[] {
      return content(item);
    },

    itemClicked(item: any, index: number) {
      if (!this.isItemClickDisabled && !this.isSelectable) {
        this.$emit("item-click", item);
      } else if (this.isSelectable) {
        this.selectTableItem(item);
      }
    },

    buttonClicked(content: string | ((item: any) => string) | undefined, item: any, index: number) {
      this.$emit("button-click", content, item, index);
    },

    selectTableItem(item: any) {
      this.$emit("select-item", item, !this.getValue("isSelected", item));
    },
  },
  watch: {},
  computed: {
    displayItems(): any[] | null {
      var sortedItems = this.items ? Array.from(this.items) : null;

      if (sortedItems && this.sortByColumnIndex != null) {
        let column = this.displayColumns[this.sortByColumnIndex];
        var collator = new Intl.Collator("de", { numeric: true });
        let vue = this;
        if (this.sortAscending) {
          sortedItems.sort(function (a: any, b: any) {
            return collator.compare(
              vue.getValue(column.sortBy, a) || vue.getValue(column.td, a) || "",
              vue.getValue(column.sortBy, b) || vue.getValue(column.td, b) || ""
            );
          });
        } else {
          sortedItems.sort(function (a: any, b: any) {
            return -collator.compare(
              vue.getValue(column.sortBy, a) || vue.getValue(column.td, a) || "",
              vue.getValue(column.sortBy, b) || vue.getValue(column.td, b) || ""
            );
          });
        }
      }

      return sortedItems;
    },

    displayColumns<T>(): TableViewColumnDefinitions<T>[] {
      return this.columns;
    },
  },
});
